
import { BranchRouting } from './branch/branch.routing';
import { CustomFromRouting } from './custom-form/custom-form.router';
import { DriverRouting, DriverRoutingBreadcrumbs } from './driver/driver.routing';
import { EmployeeBillingRouting } from './employeebilling/employeebilling.routing';
import { EmployeeDetailsRouting } from './employeedetails/employeedetails.routing';
import { HolidayComponent } from './holiday-pattern/holiday.component';
import { InformationComponent } from './information.component';
import { ManageVehicleDriverRouting, ManageVehicleDriverRoutingBreadcrumbs } from './manage-vehicle-driver/manage-vehicle-driver.routing';
import { NotificationsComponent } from './notifications/notifications.component';
import { TransportOrganizationRouting, TransportOrganizationRoutingBreadcrumbs } from './organization/transport-organization.routing';

import { ParkingRouting } from './parking/parking.routing';
import { PaymentHistoryRouting } from './paymenthistory/paymenthistory.routing';
import { AddShiftComponent } from './shift/add-shift/add-shift.component';
import { EditShiftComponent } from './shift/edit-shift/edit-shift.component';
import { ListShiftComponent } from './shift/list-shift/list-shift.component';
import { SingleViewShiftComponent } from './shift/list-shift/single-view-shift';
import { ShiftRouter } from './shift/shift.router';
import { TransportManagerAccountBreadcrumbs, transportManagerAccountRouting } from './transport-manager-account/transport-manager-account.routing';
import { VehicleRouting, VehicleRoutingBreadcrumbs } from './vehicle/vehicle.routing';
import { VendorRouting } from './vendor/vendor.routing';


// users


export const InformationRouting = [
    // { path: '', redirectTo: 'vehicle', pathMatch: 'full' },
    { path: '', component: InformationComponent},
    { path: 'vehicle', children: VehicleRouting },
    { path: 'vendor', children: VendorRouting },
    { path: 'manage', children: ManageVehicleDriverRouting},
    { path: 'driver', children: DriverRouting },
    { path: 'payment-History', children: PaymentHistoryRouting },
    /* { path: 'employee', children: EmployeeDetailsRouting },
    { path: 'employee-billing', children: EmployeeBillingRouting },
    { path:'shift',children:ShiftRouter},
    { path: 'branch', children:BranchRouting },
    { path: 'parking', children:ParkingRouting },
    { path: 'notification', component:NotificationsComponent },
    { path: 'holiday', component:HolidayComponent },
    { path: 'custom-form', children:CustomFromRouting },
 */
    { path: 'orgInfo', children:TransportOrganizationRouting},
    { path: 'account', children:transportManagerAccountRouting},
    // { path: 'users', children:UsersRouting}
];

// export const InformationRoutingBreadcrumbs = [
//  
    // { name: 'Vendor', path: '/vendor' },
    // { name: 'Vehicle', path: '/vehicle' ,children:VehicleRoutingBreadcrumbs },
    // { name: 'Driver', path: '/driver', children:DriverRoutingBreadcrumbs},
    // { name: 'Manage', path: '/manage', children:ManageVehicleDriverRoutingBreadcrumbs},
    // { name: 'organization',  path:'/orgInfo', children: TransportOrganizationRoutingBreadcrumbs},
    // { name: 'Account', path:'/account',children:TransportManagerAccountBreadcrumbs}
    /* { name: 'Employee', path: '/employee' },
    { name: 'List Shift', path: '/list-shift'},
    { name: 'Employee', path: '/employee' },
    { name: 'Employee', path: '/employee' },
    { name: 'Employee', path: '/employee' },
    { name: 'Employee', path: '/employee' },
 */
// ];